import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { horsesApi } from 'api/horses'
import { EHorseStatus } from 'models/horse'
import { IHorsesState } from './types'

const initialState: IHorsesState = {
  moderationCount: 0
}

// Бейджу нужно только общее число из count, поэтому сам список — из одной лошади
export const getModerationHorsesCount = createAsyncThunk(
  'horses/getModerationHorsesCount',
  async () => {
    const response = await horsesApi.getHorses({
      skip: '0',
      limit: '1',
      statuses: [EHorseStatus.MODERATION]
    })
    return response.data.count
  }
)

const horsesSlice = createSlice({
  name: 'horses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getModerationHorsesCount.fulfilled, (state, action) => {
        state.moderationCount = action.payload
      })
      .addCase('app/logout', () => initialState)
  }
})

export default horsesSlice.reducer
